import { render, staticRenderFns } from "./MondayWebforms.vue?vue&type=template&id=1c57c765&"
import script from "./MondayWebforms.vue?vue&type=script&lang=js&"
export * from "./MondayWebforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports